import React from 'react';
import { Link } from 'react-router-dom';
import episodes from './episodes';

const Sidebar = () => {
  return (
    <nav className='sidebar'>
      <div className='sidebar-contact'>
        <Link to='/contact' className='contact-link'>
          Contact
        </Link>
      </div>
      <div className='episodes-list'>
        {episodes.map((episode, index) => (
          <Link
            key={episode.id}
            to={`/watch/${episode.id}`}
            className='episode-link'
          >
            {index === 12 ? 'Interlude' : `Episode ${index + 1}`}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Sidebar;
